import { MenuItem, MenuHeading } from '@kasasa/fbase-components/lib';

const menuItems: (MenuItem | MenuHeading)[] = [

  { icon: '', label: 'Job Executions', to: { name: 'jobexecutions' } },
  { icon: '', label: 'Reports', to: { name: 'reports' } },
  { icon: '', label: 'File Load History', to: { name: 'fileloadhistory' } },
  { icon: '', label: 'Import Summary', to: { name: 'importsummary' } },
  { icon: '', label: 'Consumer/Account Details', to: { name: 'consumeraccountsearch' } },
  { icon: '', label: 'Qualifications/Rewards Summary', to: { name: 'qualificationsrewardssummary' } },
  { icon: '', label: 'Qualification Override', to: { name: 'qualificationoverride' } },
  { icon: '', label: 'Rewards Validation', to: { name: 'rewardsvalidation' } },
  { icon: '', label: 'Recomp Summary', to: { name: 'recompsummary' } },
  { icon: '', label: 'Audit Messages', to: { name: 'auditmessages' } },
];

export default menuItems;
